// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"390":"css/filament/catering-portal","552":"css/main"}[chunkId] + ".css";
};